export default {
    initscript: function() {
      update(document.body);
    },
    /**
     * @param {Element} container 
     */
    updateScript: function (container) {
      update(container)
    }
  };

function update(container) {
  let ancorLinks = container.querySelectorAll("a[href^='#']");
  ancorLinks.forEach(ancorLink => {
    ancorLink.onclick = event => {
      event.preventDefault();
      let ancorElementId = ancorLink.getAttribute("href").substring(1);
      let ancorElement = document.getElementById(ancorElementId);
      if(ancorElement) {
        if(!ancorElement.hasAttribute("tabindex")) {
          ancorElement.tabIndex = -1;
        }
        ancorElement.focus();
        ancorElement.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    };
  });
}